import axiosInstance from "../Interceptors/axiosInstance.jsx";

const BASE = "homepage/hero-banner-buttons";

export const getHeroBannerButtonsList = async () => {
  return await axiosInstance.get(`${BASE}/getlist`);
};

export const getHeroBannerButtonById = async (id) => {
  const response = await axiosInstance.get(`${BASE}/get/${id}`);
  return response.data?.result ?? response.data;
};

export const addHeroBannerButton = async (payload) => {
  return await axiosInstance.post(`${BASE}/add`, payload);
};

export const updateHeroBannerButton = async (payload) => {
  return await axiosInstance.put(`${BASE}/update`, payload);
};

export const deleteHeroBannerButton = async (id) => {
  return await axiosInstance.delete(`${BASE}/delete/${id}`);
};
